
import { FormSection, FormStep } from "@/models";
import { DroppableProvided } from "react-beautiful-dnd";
import { Draggable } from "react-beautiful-dnd";
import FormSectionComponent from "./FormSection";

interface FormSectionListProps {
  provided: DroppableProvided;
  sections: FormSection[];
  step?: FormStep;
  onSectionUpdated: () => Promise<void>;
  onDeleteSection: (sectionId: number) => Promise<void>;
  isParentSubmitting?: boolean;
  onEditSection: (section: FormSection) => void;
  onStepUpdated: () => Promise<void>;
}

const FormSectionList = ({ 
  provided, 
  sections, 
  step,
  onSectionUpdated,
  onDeleteSection,
  isParentSubmitting = false,
  onEditSection,
  onStepUpdated
}: FormSectionListProps) => {
  return (
    <div
      {...provided.droppableProps}
      ref={provided.innerRef}
      className="space-y-6"
    >
      {sections.map((section, index) => {
        const draggableId = `section-${section.id}`;
        console.log("Rendering section with draggable ID:", draggableId);
        
        return (
          <Draggable 
            key={draggableId}
            draggableId={draggableId}
            index={index}
          >
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                className={`${snapshot.isDragging ? 'opacity-70 shadow-lg' : 'opacity-100'} transition-all`}
              >
                <FormSectionComponent 
                  section={section}
                  onSectionUpdated={onStepUpdated}
                  onDeleteSection={onDeleteSection}
                  onEditSection={onEditSection}
                  isParentSubmitting={isParentSubmitting}
                  step={step}
                  index={index}
                  dragHandleProps={provided.dragHandleProps}
                />
              </div>
            )}
          </Draggable>
        );
      })}
      {provided.placeholder}
    </div>
  );
};

export default FormSectionList;
